import {jssPreset, StylesProvider, ThemeProvider as BaseThemeProvider} from '@yandex-taxi/go-web-components'
import {create} from 'jss'
import rtl from 'jss-rtl'
import React from 'react'

import {theme} from './theme'

let plugins = jssPreset().plugins

if (theme.direction === 'rtl') {
  plugins = plugins.concat(rtl())
}

const jss = create({
  plugins,
})

const ThemeProvider: React.FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <StylesProvider jss={jss}>
    <BaseThemeProvider theme={theme}>{children}</BaseThemeProvider>
  </StylesProvider>
)

export default ThemeProvider
